module.exports = __webpack_public_path__ + "static/media/Rahbar Logo Final.28867072.jpg";